import React from "react";
import { Button, FilterIcon } from "@fluentui/react-northstar";

export interface FilterNotesButtonProps {
    isActive: boolean;
    onClick: () => void;
}

const FilterNotesButton: React.FC<FilterNotesButtonProps> = (props) => {
    return <Button icon={<FilterIcon />} iconOnly onClick={props.onClick} primary={props.isActive} />;
};

export default FilterNotesButton;
